import { jsx as i } from "react/jsx-runtime";
import "react";
var l = (t) => /* @__PURE__ */ i("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: /* @__PURE__ */ i("path", {
    d: "M13.3329 7.11133C13.8238 7.11133 14.2218 7.5093 14.2218 8.00022C14.2218 8.49114 13.8238 8.88911 13.3329 8.88911L2.66623 8.88911C2.17531 8.88911 1.77734 8.49114 1.77734 8.00022C1.77734 7.5093 2.17531 7.11133 2.66623 7.11133L13.3329 7.11133Z",
    fill: "white"
  })
});
export {
  l as default
};
